import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useQueryString from "utils/hooks/useQueryString";

export const SelectBox = ({
  options,
  values,
  selected,
  setSelected = (f) => f,
  fetchList = (f) => f,
}) => {
  const [toggleSelectBox, setToggleSelectBox] = useState(false);
  const selectBoxRef = useRef(null);
  const queryParams = useQueryString();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    // selectBox 외부 클릭했을 때, 닫기
    const handleClickOutside = (e) => {
      if (toggleSelectBox && !selectBoxRef.current.contains(e.target))
        setToggleSelectBox(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  useEffect(() => {
    // 새로고침 했을 때 주소의 파라미터는 그대로인데 selected의 상태가 초기화 되어
    // 리스트 목록과 selected 상태가 일치하지 않게 된다.

    // values 요소들 중 주소의 parameter에서 truthy 값인 요소가 있다면
    // 해당 요소는 selectBox에서 선택된 요소이기 때문에 tempSelectedValue에 담는다.
    const [tempSelectedValue] = values.filter(
      (value) => !!queryParams[value] === true
    );

    // values에서 tempSelectedValue의 index를 찾아 tempValueIndex에 담는다.
    const tempValueIndex = values.indexOf(tempSelectedValue);

    // tempSelectedValue가 undefined라면 options의 "전체"가 selectBox에서 선택된 것이다.
    // 따라서 selected 상태를 options의 "전체"에 해당하는 값으로 바꾼다.
    // 하지만 undefined가 아닐 때에는 options에서 tempSelectedValue에 해당하는 값으로
    // selected 상태를 바꾼다.
    if (tempSelectedValue === undefined) return setSelected(options[0]);
    setSelected(options[tempValueIndex]);
  }, [queryParams, setSelected, values, options]);

  // selectBox 토글하기
  const handleToggleSelectBox = () => {
    setToggleSelectBox(!toggleSelectBox);
  };

  // option 선택하기
  const handleChangeSelectedOption = (option, value) => {
    handleToggleSelectBox();
    setSelected(option);
    fetchList(value);
  };

  return (
    <div
      className={`selectBox ${toggleSelectBox ? "active" : ""}`}
      onClick={handleToggleSelectBox}
      ref={selectBoxRef}
    >
      <div className="selected">
        <div className="selected_value">{selected}</div>
      </div>
      <div className="options">
        <ul>
          {options.map((option, idx) => {
            if (values[idx] === "user" && auth.authenticated === false)
              return null;

            return (
              <li
                key={idx}
                data-value={values[idx]}
                className={`${option === selected ? "active" : ""}`}
                onClick={(e) => {
                  handleChangeSelectedOption(option, values[idx]);
                }}
              >
                {option}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
